export default __webpack_public_path__ + "static/gabijackpic-98c78e1a636d8ffb20c24508ecca7b65.png";